import { createSlice } from "@reduxjs/toolkit";

const jewelleryCartSlice = createSlice({
  name: "jewelleryCart",
  initialState: {
    loading: false,
    updating: false,
    checkingOut: false,
    items: [],
    error: null,
    checkout: null,
  },
  reducers: {
    fetchJewelleryCartRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchJewelleryCartSuccess: (state, action) => {
      state.loading = false;
      state.updating = false;
      state.items = action.payload || [];
    },
    fetchJewelleryCartFailure: (state, action) => {
      state.loading = false;
      state.updating = false;
      state.error = action.payload;
    },
    addJewelleryToCartRequest: (state) => {
      state.updating = true;
      state.error = null;
    },
    addJewelleryToCartFailure: (state, action) => {
      state.updating = false;
      state.error = action.payload;
    },
    removeJewelleryFromCartRequest: (state) => {
      state.updating = true;
      state.error = null;
    },
    removeJewelleryFromCartFailure: (state, action) => {
      state.updating = false;
      state.error = action.payload;
    },
    checkoutJewelleryCartRequest: (state) => {
      state.checkingOut = true;
      state.checkout = null;
      state.error = null;
    },
    checkoutJewelleryCartSuccess: (state, action) => {
      state.checkingOut = false;
      state.checkout = action.payload || null;
    },
    checkoutJewelleryCartFailure: (state, action) => {
      state.checkingOut = false;
      state.error = action.payload;
    },
    resetJewelleryCheckout: (state) => {
      state.checkingOut = false;
      state.checkout = null;
    },
  },
});

export const {
  fetchJewelleryCartRequest,
  fetchJewelleryCartSuccess,
  fetchJewelleryCartFailure,
  addJewelleryToCartRequest,
  addJewelleryToCartFailure,
  removeJewelleryFromCartRequest,
  removeJewelleryFromCartFailure,
  checkoutJewelleryCartRequest,
  checkoutJewelleryCartSuccess,
  checkoutJewelleryCartFailure,
  resetJewelleryCheckout,
} = jewelleryCartSlice.actions;

export default jewelleryCartSlice.reducer;
